import React from 'react'
import { generateId } from '@ztechapps/common.utils'
import { Form } from 'react-bootstrap'
import type { FormCheckProps } from 'react-bootstrap'
import type { FieldEditorInjectedProps } from '../FieldEditorInjectedProps'

export type RadioInputProps = Omit<FormCheckProps, 'form'> &
  FieldEditorInjectedProps & {
    name: string
    submitting?: boolean
  }

/**
 * This is the default radio that works well with inline inputs
 * This is from the default bootstrap implementation
 * @param name
 * @param disabled
 * @param submitting
 * @param rest
 * @constructor
 */
export const RadioInput = ({
  name,
  disabled,
  submitting,
  form: _form,
  meta: _meta,
  isDisabled: _isDisabled,
  ...rest
}: RadioInputProps) => {
  const idRef = React.useRef(generateId(3))
  const id = `name__${idRef.current}`

  return <Form.Check type="radio" name={name} id={id} disabled={disabled || submitting} {...rest} />
}
